import { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import Cookies from 'js-cookie';
import commonStrings from 'modules/labs/common/strings';
import { contextToPageNameMap } from 'constants/contexts';
import { status } from 'constants/general';
import Loader from 'modules/shared/common/components/Loader';

import { getUpperLevelDomain } from 'utils/functions/authentication';
import {
  HeaderWrapper,
  HeaderPageName,
  HeaderUserNameWrapper,
  HeaderUserName,
  HeaderLogoutPopup,
  HeaderLogout,
  HeaderUserNameLoaderWrapper,
} from './Header.style';
// ###############################################################
// <------------------------ Constants -------------------------->
// ###############################################################
// ###############################################################
// <---------------------- End Constants ------------------------>
// ###############################################################
const Header = ({ loginInfo }) => {
  // ###############################################################
  // <------------------------- Globals --------------------------->
  // ###############################################################
  const context = useSelector(state => state.common.context);

  const userNameWrapperRef = useRef(null);
  // ###############################################################
  // <----------------------- End Globals ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useState --------------------------->
  // ###############################################################
  const [isLogoutPopupOpen, setIsLogoutPopupOpen] = useState(false);
  // ###############################################################
  // <---------------------- End useState ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useEffect -------------------------->
  // ###############################################################
  useEffect(() => {
    const handleClickOutside = event => {
      if (userNameWrapperRef.current && userNameWrapperRef.current.contains(event.target) === false)
        setIsLogoutPopupOpen(false);
    };
    document.addEventListener('click', handleClickOutside, true);

    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, [userNameWrapperRef]);
  // ###############################################################
  // <---------------------- End useEffect ------------------------>
  // ###############################################################
  // ###############################################################
  // <--------------------- rest of hooks ------------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------- End rest of hooks ---------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Logic ---------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Logic -------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Actions --------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- End Actions ------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- UI Handlers ------------------------->
  // ###############################################################
  const handleUsernameClick = () => {
    setIsLogoutPopupOpen(prevState => !prevState);
  };

  const handleLogoutClick = () => {
    setIsLogoutPopupOpen(false);
    const domain = getUpperLevelDomain();
    Cookies.remove('veezAuth', { domain });
    Cookies.remove('opsReturnURL');
    document.location.href = '/login';
  };
  // ###############################################################
  // <--------------------- End UI Handlers ----------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Render --------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Render ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Return UI ------------------------->
  // ###############################################################
  const pageName = contextToPageNameMap[context];
  return (
    <HeaderWrapper>
      <HeaderPageName>{pageName}</HeaderPageName>
      {((loginInfo.status === status.SHOULD_CALL_API || loginInfo.status === status.FETCHING) && (
        <HeaderUserNameLoaderWrapper>
          <Loader width={16} height={16} thickness={4} />
        </HeaderUserNameLoaderWrapper>
      )) || (
        <HeaderUserNameWrapper ref={userNameWrapperRef}>
          <HeaderUserName
            onClick={() => handleUsernameClick()}
          >{`${commonStrings.header.userNameText} ${loginInfo.details.data.username}`}</HeaderUserName>
          {isLogoutPopupOpen && (
            <HeaderLogoutPopup>
              <HeaderLogout onClick={() => handleLogoutClick()}>
                {commonStrings.header.logoutText}
              </HeaderLogout>
            </HeaderLogoutPopup>
          )}
        </HeaderUserNameWrapper>
      )}
    </HeaderWrapper>
  );
  // ###############################################################
  // <----------------------- End Return UI ----------------------->
  // ###############################################################
};

Header.propTypes = {
  loginInfo: PropTypes.shape({
    status: PropTypes.string,
    details: PropTypes.shape({
      data: PropTypes.shape({
        username: PropTypes.string,
      }),
    }),
  }).isRequired,
};

Header.defaultProps = {};

export default Header;
